
import React,  {Alert,Component} from 'react';
import {useEffect} from 'react';
import { Redirect } from 'react-router-dom';
import axios from 'axios';
import Carousel from 'react-bootstrap/Carousel';
import TextField from '@material-ui/core/TextField';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import PersonIcon from '@material-ui/icons/Person';
import SearchIcon from '@material-ui/icons/Search';
import SendIcon from '@material-ui/icons/Send';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { makeStyles } from '@material-ui/core/styles';
import { green, purple } from '@material-ui/core/colors';
import Autocomplete from '@material-ui/lab/Autocomplete';
import queryString from 'query-string';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import ReadMoreIcon from '@mui/icons-material/ReadMore';
import AssignmentIcon from '@mui/icons-material/Assignment';
import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOver';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto';
import '../App.css';
import { Nav,Navbar,Button,Form,Row,Modal,Col} from 'react-bootstrap';
import Loader from "react-js-loader";
import { convertToRaw, convertFromRaw, EditorState, Editor,ContentState,RichUtils } from 'draft-js';
import 'draft-js/dist/Draft.css';
import { convertToHTML, convertFromHTML } from 'draft-convert';
import { stateToHTML } from "draft-js-export-html";
import draftToHtmlPuri from "draftjs-to-html";


class Toursitinerary extends Component{
    
    constructor(props) {
    super(props);
      this.state = {
        editorState: EditorState.createEmpty(),
        selectedFile: null,
        selectedOption: null,
        listuser: [],
        modaladd:false,
        modalupdate: false,
        modaldelete: false,
        modaladdimage : false,
        listitinerrary: [],
        listfile : [],
        listitinerary : [],
        listtours : [],
        listimage : [],
        idimagetours :0,
        titletoursedit:'',
        idlistfile:0,
        title:'',
        description:'',
        roadmap:'',
        loadershow:false,
        imagefilename:'',
        editorContentHtml:'',
        tokenvalue : '',
        imageitinerary:'',
        iditinerary:0,
        idday:0,
        toursname:'',
        idtours:0,
        latitude:'',
        longitude:'',
        errormessage:"",
        imagePreviewUrl: ""

      };

      this.selecttours = this.selecttours.bind(this);

  }

//SELECT TOURS
selecttours(e) {
  this.setState({ idtours: e.target.value });
}
  

  componentWillMount() {

    document.title = "Tours itinerary";

    let tokenuser = sessionStorage.getItem('usertype');
  
    if(tokenuser === null || tokenuser === 'Undefined'){

      this.setState({ tokenexist: false})
      return

    }else{

      this.setState({ tokenvalue: tokenuser})
      this.reloaddata();
      
    }

  }

  reloaddata () {

    if(this.state.tokenvalue !== ''){

          this.setState({ reload: true})
          
    }

  }
    
  async componentDidMount() { 

    const response = await fetch('https://exotic-madagascar.com/wbs/tours/selectitinerary.php');
    const data = await response.json();
    this.setState({ listitinerary: data})

     //liste des tours
    const responsetours = await fetch('https://exotic-madagascar.com/wbs/tours/toursitinerary.php');
    const datatours = await responsetours.json();
    this.setState({ listtours: datatours}) 
  
  }

  onFileChange = event => { 
    // Update the state 
    this.setState({
      selectedFile: event.target.files[0],
      imagefilename : event.target.files[0].name,
     }); 

    const file = event.target.files[0];
    // Créer une URL d'aperçu pour l'image
    const reader = new FileReader();
    reader.onload = () => {
      this.setState({
        imagePreviewUrl: reader.result
      });
    };
    reader.readAsDataURL(file);


  }; 
   
  // On file upload (click the upload button) 
  additinerary = () => { 

    {/*
    if(this.state.selectedFile === null || this.state.selectedFile === 'null'){

      this.setState({
        loadershow: false,
        textloading:'Please select a file.'
      });
      
      return;
    
    }
    */}

     if(parseInt(this.state.idtours) === 0 ){

      this.setState({
         errormessage:"Please select tour.",
      });
      
      return;
    
    }

    if(parseInt(this.state.idday) === 0 ){

      this.setState({
         errormessage:"Please select day.",
      });
            
      return;
    
    }


    if(this.state.title === '' ){

      this.setState({
         errormessage:"Please put make a title.",
      });
      
      return;
    
    }

    if(this.state.latitude === '' ){

      this.setState({
         errormessage:"Please put latitude.",
      });
      
      return;
    
    }

    if(this.state.longitude === '' ){

      this.setState({
         errormessage:"Please put longitude.",
      });
      
      return;
    
    }

    {/*
    if(this.state.description === '' ){

      this.setState({
        loadershow: false,
        textloading:'Please put make a description.'
      });
      
      return;
    
    }
    */}

    

    // Create an object of formData 
    const formData = new FormData(); 


    formData.append("idtour",this.state.idtours);
    formData.append("daytour",this.state.idday);
    formData.append("title",this.state.title);
    formData.append("description",this.state.description);
    formData.append("latitude",this.state.latitude);
    formData.append("longitude",this.state.longitude);

    if(this.state.selectedFile !== null){

      formData.append( 
        "image_itinerary", 
        this.state.selectedFile, 
        this.state.selectedFile.name,
      ); 

    }

    this.setState({
      loadershow: true,
      textloading:'Add itinerary file ...'
    });
    

    //formData.append("description",this.state.description);
    //formData.append("roadmap",htmlPuri);
   
    // Details of the uploaded file 
   // console.log(this.state.selectedFile); 

   
    // Request made to the backend api 
    // Send formData object 
    axios.post("https://exotic-madagascar.com/wbs/tours/additinerary.php", formData)
    .then(res => {
  
      //alert(JSON.stringify(res.data));
      this.setState({ listitinerary : res.data});

      this.loaderdesactive();

  })

}

loaderdesactive(){

  
  this.setState({
    errormessage:'',
    imageitinerary:'',
    iditinerary:0,
    idday:0,
    toursname:'',
    idtours:0,
    latitude:'',
    longitude:'',
    loadershow: false,
    selectedFile:null,
    idlistfile: '',
    title: '',
    description: '',
    extensionfile:'',
    imagefilename:'',
    textloading:'',
    modaladd:false,
    modaldelete:false,
    modalupdate:false,
    imagePreviewUrl: "",
  });
  
}

showadditinerary(){

  this.setState({
    idlistfile: 0,
    title: '',
    description: '',
    roadmap:'',
    modaladd: true
  })

}

showupdatetours(iditinerary,idtours,idday,title,description,latitude,longitude,imageitinerary){

  
  this.setState({
    iditinerary: iditinerary,
    idtours: idtours,
    idday: idday,
    title: title,
    description: description,
    latitude: latitude,
    longitude: longitude,
    imageitinerary : imageitinerary,
    modalupdate: true
  })

}

updateitinerary(htmlPuri){


       if(parseInt(this.state.idtours) === 0 ){

      this.setState({
         errormessage:"Please select tour.",
      });
      
      return;
    
    }

    if(parseInt(this.state.idday) === 0 ){

      this.setState({
         errormessage:"Please select day.",
      });
            
      return;
    
    }


    if(this.state.title === '' ){

      this.setState({
         errormessage:"Please put make a title.",
      });
      
      return;
    
    }

    if(this.state.latitude === '' ){

      this.setState({
         errormessage:"Please put latitude.",
      });
      
      return;
    
    }

    if(this.state.longitude === '' ){

      this.setState({
         errormessage:"Please put longitude.",
      });
      
      return;
    
    }

  this.setState({
    loadershow: true,
    textloading: 'Updating itinerary ...'
  });

  // Create an object of formData 
    const formData = new FormData(); 


    formData.append("iditi",this.state.iditinerary);
    formData.append("idtour",this.state.idtours);
    formData.append("daytour",this.state.idday);
    formData.append("title",this.state.title);
    formData.append("description",this.state.description);
    formData.append("latitude",this.state.latitude);
    formData.append("longitude",this.state.longitude);

    if(this.state.selectedFile !== null){

      formData.append( 
        "image_itinerary", 
        this.state.selectedFile, 
        this.state.selectedFile.name,
      ); 

    }

    this.setState({
      loadershow: true,
      textloading:'Update itinerary ...'
    });
    

    //formData.append("description",this.state.description);
    //formData.append("roadmap",htmlPuri);
   
    // Details of the uploaded file 
   // console.log(this.state.selectedFile); 

   
    // Request made to the backend api 
    // Send formData object 
    axios.post("https://exotic-madagascar.com/wbs/tours/updateitinerary.php", formData)
    .then(res => {
  
      //alert(JSON.stringify(res.data));
      this.setState({ listitinerary : res.data});

      this.loaderdesactive();

    })


    return;

  if(this.state.selectedFile === null){

    fetch(`https://exotic-madagascar.com/wbs/tours/updatefile.php`,{                  
        
      method:'post',
      headers: {'Content-Type':'application/x-www-form-urlencoded'},
      body: queryString.stringify({
        idtours: this.state.idlistfile,
        title : this.state.title,
        description:this.state.description,
        roadmap:htmlPuri,
        extensionfile:this.state.extensionfile,
      })

      })

      .then(response => response.json())
      .then(data => {

      if(JSON.stringify(data).replace(/\"/g, "") === 'Error'){

        this.setState({ errorform: true, errormessage: 'Error update file.' });
        return;
      
      }

        this.setState({
          loadershow: false,
          selectedFile:null,
          idlistfile: '',
          title: '',
          description: '',
          extensionfile:'',
          imagefilename:'',
          textloading:'',
          modalupdate: false
        })

        this.refreshdata();

      })
      .catch(error => {
        this.setState({ errormessage: error});
      });  

  }else{

    const formData = new FormData(); 
   
    formData.append( 
      "image", 
      this.state.selectedFile, 
      this.state.selectedFile.name,
    ); 

    formData.append("idfile",this.state.idlistfile);
    formData.append("extension",this.state.extensionfile);
   
    axios.post("https://exotic-madagascar.com/wbs/tours/removeaddfile.php", formData)
    .then(res => {

      fetch(`https://exotic-madagascar.com/wbs/tours/updatefile.php`,{                  
        
        method:'post',
        headers: {'Content-Type':'application/x-www-form-urlencoded'},
        body: queryString.stringify({
          idtours: this.state.idlistfile,
          title : this.state.title,
          description:this.state.description,
          roadmap:htmlPuri,
          extensionfile:this.state.extensionfile,
        })
  
        })
  
        .then(response => response.json())
        .then(data => {
  
        if(JSON.stringify(data).replace(/\"/g, "") === 'Error'){
  
          this.setState({ errorform: true, errormessage: 'Error update file.' });
          return;
        
        }
  
          this.setState({
            loadershow: false,
            selectedFile:null,
            idlistfile: '',
            title: '',
            description: '',
            extensionfile:'',
            imagefilename:'',
            textloading:'',
            modalupdate: false
          })
  
          this.refreshdata();
  
        })
        .catch(error => {
          this.setState({ errormessage: error});
        });  

  })


  }

}

showdeletetours(iditinerary,toursname,idday,titleitinerary,imageitinerary){
  
  
  this.setState({
    iditinerary: iditinerary,
    toursname:toursname,
    idday:idday,
    title: titleitinerary,
    imageitinerary:imageitinerary,
    modaldelete: true
  })

}

async selectimagetours(idtours,tourstitle){

  this.setState({
    loadershow: false,
    selectedFile:null,
    idlistfile: idtours,
    titletoursedit: tourstitle,
    modaladdimage: true
  })

  const response = await fetch('https://exotic-madagascar.com/wbs/tours/gallerytours/selectimagetours.php',{                  
        method:'post',
        headers: {'Content-Type':'application/x-www-form-urlencoded'},
        body: queryString.stringify({
          idtrs:idtours
        })});
  const data = await response.json();

  this.setState({
    listimage:data,
  })

  const responseitinerary = await fetch('https://exotic-madagascar.com/wbs/tours/gallerytours/selectitinerarytour.php',{                  
        method:'post',
        headers: {'Content-Type':'application/x-www-form-urlencoded'},
        body: queryString.stringify({
          idtrs:idtours
        })});
  const dataitinerrary = await responseitinerary.json();

  this.setState({
    listitinerrary:dataitinerrary,
  })

}

addimagetours = () => { 

  if(this.state.selectedFile === null || this.state.selectedFile === 'null'){

    this.setState({
      loadershow: false,
      textloading:'Please select a file.'
    });
    
    return;
  
  }

  this.setState({
    loadershow: true,
    textloading:'Uploading file ...'
  });

  // Create an object of formData 
  const formData = new FormData(); 
 
  // Update the formData object 
  formData.append( 
    "image", 
    this.state.selectedFile, 
    this.state.selectedFile.name,
  ); 

  formData.append("idtours",this.state.idlistfile);
 
  // Request made to the backend api 
  // Send formData object 
  axios.post("https://exotic-madagascar.com/wbs/tours/gallerytours/addfile.php", formData)
  .then(res => {

    this.setState({
      listimage : res.data,
      loadershow: false,
      textloading:'',
    });

  })

}

deleteimageitinerary(imageitinerary){

  fetch(`https://exotic-madagascar.com/wbs/tours/gallerytours/deletefile.php`,{                  
        
    method:'post',
    headers: {'Content-Type':'application/x-www-form-urlencoded'},
    body: queryString.stringify({
      image_link:imageitinerary,
    })

    })

    .then(response => response.json())
    .then(data => {

    if(JSON.stringify(data).replace(/\"/g, "") === 'Error'){

      this.setState({ errorform: true, errormessage: 'Error delete file.' });
      return;

    }

    if(data.length>0){
      this.setState({
        selectedFile:null,
        listimage : data,
        modaldeleteimage: false,
      })
    }else{
      this.setState({
        selectedFile:null,
        listimage : [],
        modaldeleteimage: false,
      })
    }


    })
    .catch(error => {
      this.setState({
        tokenuser: error,
        listimage : [],
        modaldeleteimage: false,
      });
    });  

}

deleteitinerary(){

  fetch(`https://exotic-madagascar.com/wbs/tours/deleteitinerary.php`,{                  
        
    method:'post',
    headers: {'Content-Type':'application/x-www-form-urlencoded'},
    body: queryString.stringify({
      itinerarytour: this.state.iditinerary,
      image_link : this.state.imageitinerary,
    })

    })

    .then(response => response.json())
    .then(data => {

    if(JSON.stringify(data).replace(/\"/g, "") === 'Error'){

      this.setState({ errorform: true, errormessage: 'Error delete file.' });
      return;

    }

    const updatedList = this.state.listitinerary.filter((item) => item.iditinerary !== this.state.iditinerary);

    this.setState({
      idlistfile: 0,
      title: '',
      extensionfile:'',
      modaldelete: false,
       itinerarytour: 0,
      imageitinerary : '',
      listitinerary:updatedList
    })

    //this.refreshdata();

    })
    .catch(error => {
      this.setState({ tokenuser: error});
    });  

}

showdeleteimagetours(idtours,extensionfile){
  this.setState({
    loadershow: false,
    selectedFile:null,
    idimagetours: idtours,
    extensionfile : extensionfile,
    modaldeleteimage: true
  })
}

async refreshdata(){

  const response = await fetch('https://exotic-madagascar.com/wbs/tours/alltours.php');
  const data = await response.json();
  this.setState({
    listfile: data,
    loadershow: false,
    selectedFile:null,
    idlistfile: '',
    title: '',
    description: '',
    extensionfile:'',
    imagefilename:'',
    textloading:'',
  })

}

onEditorStateChange = (editorState) => {
    
  this.setState({
    editorState
  });

  this.setState({
    texthtml:convertToHTML(editorState.getCurrentContent()),
  });

};

onChange = (editorState) => {
  this.setState({
    editorState
  });
  
}

onUnderlineClick = () => {
  this.onChange(
    RichUtils.toggleInlineStyle(this.state.editorState, "UNDERLINE")
  );
};

onBoldClick = () => {
  this.onChange(RichUtils.toggleInlineStyle(this.state.editorState, "BOLD"));
};

onItalicClick = () => {
  this.onChange(
    RichUtils.toggleInlineStyle(this.state.editorState, "ITALIC")
  );
};
    
  render() {

    const htmlPuri = draftToHtmlPuri(
      convertToRaw(this.state.editorState.getCurrentContent())
    );

    const html = stateToHTML(this.state.editorState.getCurrentContent(), {
      inlineStyleFn: styles => {
        let key = "color-";
        let color = styles.filter(value => value.startsWith(key)).first();
        let a = "fontfamily-";
        let b = styles.filter(value => value.startsWith(a)).first();
        console.log(b, color);

        if (color) {
          return {
            element: "span",
            style: {
              color: color.replace(key, ""),
              fontFamily: b.replace(a, "")
            }
          };
        }
      }
    });


          return (
              
                <div className="App" style={{marginTop:'100px'}}>
                  
                  {this.state.tokenvalue === '' ?
                            

                            <Redirect push to="/"/>
                              

                            :

                            null

                    }

                    <Button className="btn"style={{ margin:"20px"}} onClick={ () => this.setState({modaladd:true})} variant="success"> <span  ><AddIcon/></span>ADD ITINERARY</Button>
                                  
                      {this.state.modaladd === true ?

                        <Modal

                        show={this.state.modaladd}
                        onHide={ () => this.loaderdesactive()}
                        dialogClassName="modal-dialog"
                        aria-labelledby="example-custom-modal-styling-title" centered
                        >
                          <Modal.Body>
                              <div className="d-flex flex-column justify-content-center">

                                <label>Tour:</label>
                                <div className='d-flex justify-content-center'>
                                  <Form.Select style={{width:'100%', marginTop:'10px', marginBottom:'10px' }} value={this.state.idtours} onChange={this.selecttours}>
                                  <option value="0"></option>
                                    {this.state.listtours.map((tours) => (
                                      <option value={tours.idtours}>{tours.titletours}</option>
                                    ))}
                                  </Form.Select>
                                </div>

                                <label>Day:</label>
                                <input style={{width:'100%', marginTop:'10px', marginBottom:'10px'}}type="number" className="form-control" value={this.state.idday} onChange={(e) => this.setState({ idday: e.target.value})} />

                                <label>Title:</label>
                                <input style={{width:'100%', marginTop:'10px', marginBottom:'10px'}}type="text" className="form-control" value={this.state.title} onChange={(e) => this.setState({ title: e.target.value})} />
                              
                                <label>Description:</label>
                                <textarea type="textarea" rows={3} style={{width:'100%'}} className="form-control" value={this.state.description} onChange={(e) => this.setState({ description: e.target.value})} />
                                
                                 <label>Latitude:</label>
                                <input style={{width:'100%', marginTop:'10px', marginBottom:'10px'}}type="text" className="form-control" value={this.state.latitude} onChange={(e) => this.setState({ latitude: e.target.value})} />

                                 <label>Longitude:</label>
                                <input style={{width:'100%', marginTop:'10px', marginBottom:'10px'}}type="text" className="form-control" value={this.state.longitude} onChange={(e) => this.setState({ longitude: e.target.value})} />

                                {this.state.imagefilename === null ?

                                  <div >
                                      No select file                    
                                  </div>

                                  :
                                  <div style={{textAlign:'center'}}>
                                    {this.state.imagefilename}
                                  </div>
                                }

                                <label htmlFor="filePicker" style={{background:"#ffc107", padding:"5px 10px", marginTop:'20px', color:'white', borderRadius:'5px',textAlign:'center' }}>Select file</label>
                                <input id="filePicker" style={{visibility:"hidden"}} type={"file"} onChange={this.onFileChange} accept="image/jpeg, image/png, image/jpg"/>

                                {/* Aperçu de l'image */}
                                <div className='d-flex justify-content-center'>
                                {this.state.imagePreviewUrl && (
                                  <div style={{ marginTop: "20px" }}>
                                    <img
                                      src={this.state.imagePreviewUrl}
                                      alt="Preview"
                                      style={{ maxWidth: "220px", maxHeight: "150px" }}
                                    />
                                  </div>
                                )}
                                </div>

                                {this.state.loadershow === true ?
                              

                                  <Loader type="spinner-cub" bgColor={'#3498db'} title={this.state.textloading} color={'#3498db'} size={100} />
                                    
            
                                  :
            
                                  null
            
                                }

                                {this.state.errormessage === "" ?

                                  null

                                  :

                                  <p style={{fontSize:"20px", color:"#d9534f", textAlign:"center"}}>{this.state.errormessage}</p>

                                }
                                
                                
                                <div className='d-flex flex-row justify-content-center'>
                                            
                                    <Button className="btn"style={{ margin:"10px", width:'150px'}} onClick={ () => this.loaderdesactive()} variant="secondary">Close</Button>
                                    {this.state.title === "" ?

                                      null

                                      :

                                      <Button className="btn" style={{ margin:"10px",right: 0, width:'150px'}} onClick={() => this.additinerary()} variant="success">Add itinerary</Button>

                                    }
                                    
                                </div>

                            </div>          
                          
                        </Modal.Body>
                        </Modal>

                        :

                        null

                        }

                  
                  {this.state.modalupdate === true ?

                  <Modal
                  
                  show={this.state.modalupdate}
                  onHide={ () => this.loaderdesactive()}
                  dialogClassName="modal-dialog"
                  aria-labelledby="example-custom-modal-styling-title" centered
                  >

                      <Modal.Body>
                          <div className="d-flex flex-column justify-content-center">

                            <label>Tour:</label>
                                <div className='d-flex justify-content-center'>
                                  <Form.Select style={{width:'100%', marginTop:'10px', marginBottom:'10px' }} value={this.state.idtours} onChange={this.selecttours}>
                                  <option value="0"></option>
                                    {this.state.listtours.map((tours) => (
                                      <option value={tours.idtours}>{tours.titletours}</option>
                                    ))}
                                  </Form.Select>
                                </div>

                                <label>Day:</label>
                                <input style={{width:'100%', marginTop:'10px', marginBottom:'10px'}}type="number" className="form-control" value={this.state.idday} onChange={(e) => this.setState({ idday: e.target.value})} />

                                <label>Title:</label>
                                <input style={{width:'100%', marginTop:'10px', marginBottom:'10px'}}type="text" className="form-control" value={this.state.title} onChange={(e) => this.setState({ title: e.target.value})} />
                              
                                <label>Description:</label>
                                <textarea type="textarea" rows={3} style={{width:'100%'}} className="form-control" value={this.state.description} onChange={(e) => this.setState({ description: e.target.value})} />
                                
                                 <label>Latitude:</label>
                                <input style={{width:'100%', marginTop:'10px', marginBottom:'10px'}}type="text" className="form-control" value={this.state.latitude} onChange={(e) => this.setState({ latitude: e.target.value})} />

                                 <label>Longitude:</label>
                                <input style={{width:'100%', marginTop:'10px', marginBottom:'10px'}}type="text" className="form-control" value={this.state.longitude} onChange={(e) => this.setState({ longitude: e.target.value})} />

                                <div className='d-flex justify-content-center'>
                                  {this.state.imageitinerary !== null?
                                    
                                   
                                    <img src={process.env.PUBLIC_URL + './images/tours/itinerarytours/' + this.state.imageitinerary} style={{width:"220px", height:"150px"}} className="d-flex justify-content-center"/>
                                                               
                                    :

                                    null

                                  }
                                </div>

                                {this.state.imagefilename === null ?

                                  <div >
                                      No select file                    
                                  </div>

                                  :
                                  <div style={{textAlign:'center'}}>
                                   
                                    {this.state.imagefilename}
                                  
                                  </div>
                                }

                            <label htmlFor="filePicker" style={{background:"#ffc107", padding:"5px 10px", marginTop:'20px', color:'white', borderRadius:'5px',textAlign:'center' }}>Select file</label>
                            <input id="filePicker" style={{visibility:"hidden"}} type={"file"} onChange={this.onFileChange} accept=".jpg"/>
                            
                            {/* Aperçu de l'image */}
                            <div className='d-flex justify-content-center'>
                            {this.state.imagePreviewUrl && (
                              <div style={{ marginTop: "20px" }}>
                                <img
                                  src={this.state.imagePreviewUrl}
                                  alt="Preview"
                                  style={{ maxWidth: "220px", maxHeight: "150px" }}
                                />
                              </div>
                            )}
                            </div>

                            {this.state.loadershow === true ?
                              

                              <Loader type="spinner-cub" bgColor={'#3498db'} title={this.state.textloading} color={'#3498db'} size={100} />
                                
        
                              :
        
                              null
        
                            }

                            <div className='d-flex flex-row justify-content-center'>
                                        
                            <Button className="btn"style={{ margin:"10px", width:'150px'}} onClick={ () => this.loaderdesactive()} variant="secondary">Close</Button>
                            <Button className="btn" style={{ margin:"10px",right: 0, width:'150px'}} onClick={() => this.updateitinerary()} variant="success">Update</Button>
                                
                            </div>

                        </div>          
                      
                    </Modal.Body>

                  </Modal>

                  :

                  null

                  }

                  {this.state.modaldelete === true ?

                  <Modal

                  show={this.state.modaldelete}
                  onHide={ () => this.setState({modaldelete:false})}
                  dialogClassName="modal-dialog"
                  aria-labelledby="example-custom-modal-styling-title" centered
                  >
                    <Modal.Body>
                                
                    <div className="d-flex flex-row justify-content-center">
                                      
                        <div className="d-flex flex-column" style={{margin:"20px"}}>
                            
                            <div className="d-flex flex-column">

                                <p style={{fontWeight:"bold", textAlign:"center", marginTop:"20px"}}>Would you like to delete itinerary </p>
                                <p style={{fontWeight:"bold", textAlign:"left", marginTop:"20px"}}>Tours: {this.state.toursname} &nbsp;</p>
                                <p style={{textAlign:"left", marginTop:"20px"}}>Title: {this.state.title} &nbsp;</p>
                                <p style={{textAlign:"left", marginTop:"20px"}}>Day {this.state.idday} &nbsp;</p>

                                <div className='d-flex justify-content-center'>
                                  {this.state.imageitinerary !== null?
                                    
                                   
                                    <img src={process.env.PUBLIC_URL + './images/tours/itinerarytours/' + this.state.imageitinerary} style={{width:"220px", height:"150px"}} className="d-flex justify-content-center"/>
                                                               
                                    :

                                    null

                                  }
                                </div>
                                <form>

                                <div className='row text-white d-flex align-items-center'>
                                            
                                      <Button className="btn"style={{ margin:"20px", width:'150px'}} onClick={ () => this.loaderdesactive()} variant="secondary">Close</Button>
                                      <Button className="btn" style={{ margin:"10px",right: 0, width:'150px'}} onClick={() => this.deleteitinerary()} variant="danger">Delete</Button>

                                </div>
                                
                              </form>
                            </div>
                            
                        </div>

                    </div>    

                  </Modal.Body>
                  </Modal>

                  :

                  null

                  }

                  <div className='centrervue' >
                  <TableContainer>
                    <Table>
                      <TableHead>
                        <TableRow>
                          
                          <TableCell >Images</TableCell>
                          <TableCell >Tours</TableCell>
                          <TableCell >Day</TableCell>
                          <TableCell >Title</TableCell>
                          <TableCell >Description</TableCell>
                          <TableCell style={{textAlign:"center"}}>Action</TableCell>
                          {/*
                          <TableCell >Add image</TableCell>
                          <TableCell >Update</TableCell>
                          <TableCell >Delete</TableCell>
                          */}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {this.state.listitinerary.map((row) => (

                          <TableRow key={row.iditinerary}>

                            <TableCell component="th" scope="row" className='verticalcenter'>

                              {row.itinerary_image !== null?

                                <img src={process.env.PUBLIC_URL + './images/tours/itinerarytours/'+row.itinerary_image } style={{width:"220px", height:"150px"}} className="verticalcenter"/>

                                :

                                <p style={{textAlign:"left"}}>No pictures</p>
                              }
                              
                            </TableCell>
                            <TableCell >{row.titletours}</TableCell>
                            <TableCell >Day {row.itinerary_day}</TableCell>
                            <TableCell >{row.itinerary_title}</TableCell>
                            <TableCell >{row.itinerary_description}</TableCell> 
                            <TableCell style={{textAlign:"center"}}>{/*<span style={{marginLeft:"20px",marginTop:"10px", color:"#292b2c"}} onClick={() => this.selectimagetours(row.iditinerary,row.itinerary_title)}><AddAPhotoIcon/></span>*/}<span style={{marginLeft:"20px", marginTop:"10px", color:"#0275d8"}} onClick={() => this.showupdatetours(row.iditinerary,row.idtour_itinerary,row. 	itinerary_day,row.itinerary_title,row.itinerary_description,row.itinerary_latitude,row.itinerary_longitude,row.itinerary_image,)}><EditIcon/></span><span style={{marginLeft:"20px", marginTop:"10px", color:"#d9534f"}} onClick={() => this.showdeletetours(row.iditinerary,row.titletours,row.itinerary_day,row.itinerary_title,row.itinerary_image)}><DeleteIcon/></span></TableCell>
                            {/*
                            <TableCell ><button type="submit" className="btn btn-success btn-circle btn-xl" onClick={() => this.selectimagetours(row.iditinerary,row.itinerary_title)}><span><AddIcon /></span></button></TableCell>
                            <TableCell ><button type="submit" className="btn btn-primary btn-circle btn-xl" onClick={() => this.showupdatetours(row.iditinerary,row.itinerary_title,row.itinerary_description)}><span><EditIcon /></span></button></TableCell>
                            <TableCell ><button type="submit" className="btn btn-danger btn-circle btn-xl" onClick={() => this.showdeletetours(row.iditinerary,row.itinerary_title,row.itinerary_image)}><span><DeleteIcon /></span></button></TableCell>
                            */}

                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  </div> 

                  {this.state.modaladdimage === true ?

                    <Modal

                    show={this.state.modaladdimage}
                    onHide={ () => this.setState({modaladdimage:false, listimage: []})}
                    dialogClassName="modal-dialog"
                    aria-labelledby="example-custom-modal-styling-title" centered
                    >
                      <Modal.Body>

                      <div className="App">
                                              
                                <div className='d-flex flex-column centerdata'>

                                  <p style={{fontWeight:'bold'}}>{this.state.titletoursedit}</p>

                                    {this.state.imagefilename === null ?

                                      <div >
                                          No select file                    
                                      </div>

                                      :

                                      this.state.imagefilename

                                    }

                                    <label htmlFor="filePicker" style={{background:"#0d6efd", padding:"5px 10px", marginTop:'20px', color:'white', borderRadius:'5px',textAlign:'center' }}> Select file </label>
                                    <input id="filePicker" style={{visibility:"hidden"}} type={"file"} onChange={this.onFileChange} accept=".jpg"/>

                                    {this.state.loadershow === true ?
                                      

                                      <Loader type="spinner-cub" bgColor={'#3498db'} title={this.state.textloading} color={'#3498db'} size={100} />
                                        
                
                                      :
                
                                      null
                
                                    }
                                    

                                    {this.state.selectedFile === null ?

                                      null

                                      :

                                      <button onClick={this.addimagetours} className="btn btn-success">ADD FILE</button> 

                                    }
                                    
                                              
                                </div> 


                            {this.state.modaldeleteimage === true ?

                                                                     
                              <div className="d-flex flex-row justify-content-center">
                                                
                                  <div className="d-flex flex-column" style={{margin:"20px"}}>
                                      
                                      <div className="d-flex flex-column">
                                          <p style={{fontWeight:"bold", textAlign:"center", marginTop:"20px"}}>Would you like to delete?</p>
                                          <div className='d-flex justify-content-center'>
                                            <img src={process.env.PUBLIC_URL + './images/tours/gallerytours/' + this.state.idimagetours + '.' + this.state.extensionfile} style={{width:"220px", height:"150px"}} className="d-flex justify-content-center"/>
                                          </div>
                                          <form>

                                          <div className='row text-white d-flex align-items-center'>
                                                      
                                                <Button className="btn"style={{ margin:"20px", width:'150px'}} onClick={ () => this.setState({modaldeleteimage:false})} variant="secondary">Close</Button>
                                                <Button className="btn" style={{ margin:"10px",right: 0, width:'150px'}} onClick={() => this.deleteimagetours()} variant="danger">Delete</Button>

                                          </div>
                                          
                                        </form>
                                      </div>
                                      
                                  </div>

                              </div>    

                            :

                            null

                            }

                            <div className='centrervue' style={{height:'500px', overflow:'auto'}}>
                              <TableContainer>
                                <Table>
                                  <TableHead>
                                    <TableRow>
                                      
                                      <TableCell >Images</TableCell>
                                      <TableCell >Delete</TableCell>
                                      
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {this.state.listimage.map((row) => (
                                      <TableRow key={row.idimagestours}>

                                        <TableCell component="th" scope="row" className='verticalcenter'><img src={process.env.PUBLIC_URL + './images/tours/gallerytours/' + row.idimagestours + '.' + row.extensionimage} style={{width:"220px", height:"150px"}} className="verticalcenter"/></TableCell>
                                        <TableCell ><button type="submit" className="btn btn-danger btn-circle btn-xl" onClick={() => this.showdeleteimagetours(row.idimagestours,row.extensionimage)}><span><DeleteIcon /></span></button></TableCell>


                                      </TableRow>
                                    ))}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </div> 
                        
                          </div>

                      
                      </Modal.Body>
                    </Modal>

                    :

                    null

                    }
               
                </div>
                
          );
        }
    
}

export default Toursitinerary;
